export const invertedMessages = {
  Application: 'Search.Label.Application',
  Default: 'certs.label.default',
};
